import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetAlertSearchAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} params
   * @param {Config} params.config
   * @param {GetAlertSearchAdsService} params.getAlertSearchAdsService
   */
  constructor({config, getAlertSearchAdsService}) {
    super()

    this._config = config
    this._getAlertSearchAdsService = getAlertSearchAdsService
  }

  /**
   * Returns an alert search object related to an ad
   * @return {Promise<AdsListValueObjectLegacy, Error>}
   */
  @tracer({metric: 'GetAlertSearchAdsUseCase#execute'})
  @AsyncInlineError()
  async execute({ad, params} = {}) {
    const [getAdAlertSearchServiceError, searchVO] = await this._getAlertSearchAdsService.execute({ad, params})

    return searchVO || Promise.reject(getAdAlertSearchServiceError)
  }
}
